/* KUTEÈ waitlist Lead — report a signup only once Shopify has CONFIRMED it.
   Bot protection can route a submit through /challenge (hCaptcha), which
   re-posts the form: a Lead sent on submit was counted twice, and abandoned
   captchas were counted too. So a valid submit only STAGES a pending signup
   in sessionStorage; the success page publishes 'kutee:waitlist_signup' once
   and forgets it. Waitlist forms carry ku_lead=confirm (set here, so only
   when this script runs) to tell the Meta custom pixel to wait for that
   event instead of counting the submit. */
(() => {
  const KEY = 'ku_lead_pending';
  const TTL_MS = 30 * 60 * 1000;
  const EVENT = 'kutee:waitlist_signup';
  const MARKER = '[data-ku-lead-marker]';

  const store = {
    get() {
      try {
        return window.sessionStorage.getItem(KEY);
      } catch (e) {
        return null;
      }
    },
    set(value) {
      try {
        window.sessionStorage.setItem(KEY, value);
      } catch (e) {
        /* private mode — the pixel then gets no Lead; non-fatal */
      }
    },
    clear() {
      try {
        window.sessionStorage.removeItem(KEY);
      } catch (e) {
        /* non-fatal */
      }
    },
  };

  const newEventId = () => {
    const c = window.crypto;
    if (c && typeof c.randomUUID === 'function') return `kwl-${c.randomUUID()}`;
    return `kwl-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
  };

  const read = () => {
    try {
      const e = JSON.parse(store.get() || 'null');
      const ok = e && typeof e.eventId === 'string' && typeof e.path === 'string' && typeof e.ts === 'number';
      return ok ? e : null;
    } catch (err) {
      return null;
    }
  };

  const fresh = (e) => Date.now() - e.ts < TTL_MS;

  // A re-submit on the same page (e.g. after an abandoned captcha) keeps the eventId but takes the latest picks.
  const stage = ({ source, contentName, secondChoice }) => {
    if (!contentName) return;
    const prev = read();
    const path = window.location.pathname;
    store.set(
      JSON.stringify({
        v: 1,
        eventId: prev && prev.path === path && fresh(prev) ? prev.eventId : newEventId(),
        source,
        path,
        content_name: contentName,
        second_choice: secondChoice || null,
        ts: Date.now(),
      })
    );
  };

  const arm = (form) => {
    const marker = form && form.querySelector(MARKER);
    if (marker) marker.value = 'confirm';
  };

  const confirmedHere = (entry) => {
    if (entry.source === 'landing') {
      return entry.path === window.location.pathname && !!document.querySelector('[data-ku-wl-success]');
    }
    if (entry.source === 'pdp') {
      return Array.from(document.querySelectorAll('[data-ku-waitlist-signed]')).some(
        (el) => el.dataset.kuWaitlistSigned === entry.content_name
      );
    }
    return false;
  };

  const confirm = () => {
    const entry = read();
    if (!entry) return;
    if (!fresh(entry)) {
      store.clear();
      return;
    }
    if (!confirmedHere(entry)) return;
    store.clear(); // before publishing, so a refresh can never send it again
    const payload = { eventId: entry.eventId, content_name: entry.content_name, source: entry.source };
    if (entry.second_choice) payload.second_choice = entry.second_choice;
    try {
      const result = window.Shopify.analytics.publish(EVENT, payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (e) {
      /* analytics must never break the page */
    }
  };

  /* PDP waitlist forms stage themselves (the landing JS stages its own picks).
     Any other customer/contact form cancels a pending signup, so its success
     page can't report a waitlist Lead. */
  window.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      const marker = form.querySelector(MARKER);
      if (marker) {
        if (marker.dataset.kuLeadSource === 'pdp') stage({ source: 'pdp', contentName: marker.dataset.kuLeadName });
        return;
      }
      if (/\/contact\b/.test(form.getAttribute('action') || '')) store.clear();
    },
    true
  );

  window.kuWaitlistLead = { stage, arm };

  const init = () => {
    document.querySelectorAll(`${MARKER}[data-ku-lead-source="pdp"]`).forEach((m) => arm(m.form));
    confirm();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
